export class AsyncTimeoutError extends Error {
  constructor(message = 'The operation timed out') {
    super(message);
    this.name = 'AsyncTimeoutError';
  }
}

/**
 * Bound UI-owned async work so a stalled auth or commerce request cannot keep
 * a loading state on screen forever. The underlying operation remains safe to
 * settle later; callers must still ignore stale results when a view unmounts.
 */
export async function withAsyncTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  message?: string,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new AsyncTimeoutError(message)), timeoutMs);
      }),
    ]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}
